const initialState = {
  personalAccessTokens: null,
  api_token: '',
  status: {
    isLoading: true,
    isCreatingToken: false,
    isRevokingToken: false,
    isSubmitting: false,
    isPopupOpen: false,
    needsMFA: false,
    needsMFAV1: false,
  },
  showFlash: false
}

const setLoading = (state, isLoading) => ({
  ...state,
  status: {
    ...state.status,
    isLoading
  }
})

const setIsCreatingToken = (state, isCreatingToken) => ({
  ...state,
  status: {
    ...state.status,
    isCreatingToken
  }
})

const setIsRevokingToken = (state, isRevokingToken) => ({
  ...state,
  status: {
    ...state.status,
    isRevokingToken
  }
})

const setShowFlashMessage = (state, showFlash) => ({
  ...state,
  showFlash
})

const startLoading = (state) => setLoading(state, true)
const stopLoading = (state) => setLoading(state, false)
const startCreateTokenLoading = (state) => setIsCreatingToken(state, true)
const stopCreateTokenLoading = (state) => setIsCreatingToken(state, false)
const startRevokeTokenLoading = (state) => setIsRevokingToken(state, true)
const stopRevokeTokenLoading = (state) => setIsRevokingToken(state, false)
const showFlashMessage = (state) => setShowFlashMessage(state, true)
const hideFlashMessage = (state) => setShowFlashMessage(state, false)

const personalAccessTokensLoaded = (state, personalAccessTokens) => ({
  ...state,
  status: {
    ...state.status,
    isLoading: false
  },
  personalAccessTokens
})

const personalAccessTokenCreated = (state, { token }) => ({
  ...state,
  status: {
    ...state.status,
    isLoading: false,
    needsMFA: false,
  },
  token
})

const personalAccessTokenRemovedFromState = (state) => ({
  ...state,
  token: null
})

const openMFAPopup = (state) => ({
  ...state,
  status: {
    ...state.status,
    needsMFA: true
  }
})

const closeMFAPopup = (state) => ({
  ...state,
  status: {
    ...state.status,
    needsMFA: false
  }
})

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'API_V2_FETCH_PERSONAL_ACCESS_TOKENS':
      return startLoading(state)
    case 'API_V2_CREATE_PERSONAL_ACCESS_TOKEN':
      return startCreateTokenLoading(state)
    case 'API_V2_REVOKE_PERSONAL_ACCESS_TOKEN':
      return startRevokeTokenLoading(state)
    case 'API_V2_FETCH_PERSONAL_ACCESS_TOKENS_SUCCESS':
      return personalAccessTokensLoaded(state, payload)
    case 'API_V2_CREATE_PERSONAL_ACCESS_TOKEN_SUCCESS':
      return personalAccessTokenCreated(state, payload)
    case 'API_V2_FETCH_PERSONAL_ACCESS_TOKENS_COMPLETE':
      return stopLoading(state)
    case 'API_V2_CREATE_PERSONAL_ACCESS_TOKEN_COMPLETE':
      return stopCreateTokenLoading(state)
    case 'API_V2_SHOW_FLASH_MESSAGE':
      return showFlashMessage(state)
    case 'API_V2_HIDE_FLASH_MESSAGE':
      return hideFlashMessage(state)
    case 'API_V2_REVOKE_PERSONAL_ACCESS_TOKEN_COMPLETE':
      return stopRevokeTokenLoading(state)
    case 'API_V2_REMOVE_PERSONAL_ACCESS_TOKEN_FROM_STATE':
      return personalAccessTokenRemovedFromState(state)
    case 'API_WEBHOOKS_MFA_REQUIRED':
      return openMFAPopup(state)
    case 'API_WEBHOOKS_MFA_CLOSE_POPUP':
      return closeMFAPopup(state)
    default:
      return { ...initialState, ...state }
  }
}
